import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const StylesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Styles",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2.56 28.02c.19-.13.34-.3.46-.5.37-.59.59-1.27.63-1.97.32-3.24 2.88-5.14 5.24-3.54s2.73 4.61-.07 6.23q-.69.405-1.44.69H7.3c-.89.35-1.82.61-2.77.78h-.09c-.44.09-.89.15-1.34.2h-.09c-.57 0-1.03-.46-1.03-1.03 0-.38.22-.73.55-.91V28Zm10.87-4.99c-.39.4-1.04.4-1.43 0l-2.85-2.88c-.19-.19-.3-.45-.3-.73 0-.57.45-1.03 1.01-1.04.28 0 .55.11.75.31l2.83 2.88a1.037 1.037 0 0 1-.01 1.47Zm-2.41-5.93L24.79 3.26a2.887 2.887 0 0 1 4.03-.62c1.28.94 1.56 2.74.62 4.03-.17.24-.38.44-.61.62L15 21.12z"
    })
  }));
};